// The front-page slot for the voice assistant: a friendly bar (slim and quiet
// on Today's side column — the rail's Ask orb is the main way in).

import { Mic, Sparkles } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useAskInfo } from '../../data/ask.ts';
import { useProfile } from '../../data/hooks.ts';
import { openVoice } from './VoiceAssistant.tsx';

const PROMPTS = ['“How much should he eat today?”', '“He’s just done a wee outside”', '“Why does he bite so much?”', '“What should we practise this week?”', '“Is he getting enough sleep?”', '“Ate all his lunch, then went down for a nap”'];

export function AskHero({ compact }: { compact?: boolean } = {}) {
  const profile = useProfile();
  // Fetch AI/speech status early so the assistant can start listening straight away.
  useAskInfo();
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setI((x) => (x + 1) % PROMPTS.length), 4500);
    return () => clearInterval(t);
  }, []);
  return (
    <button type="button" className={`ask-hero${compact ? ' ask-hero-compact' : ''}`} onClick={() => openVoice({ listen: true })}>
      <span className="ask-hero-orb" aria-hidden>
        <Mic />
      </span>
      <span className="ask-hero-text">
        <strong>
          {compact ? 'Ask or tell Arlo HQ' : 'Talk to Arlo HQ'} <Sparkles aria-hidden />
        </strong>
        <span key={i} className="ask-hero-prompt">
          {compact ? PROMPTS[i] : <>Ask anything about {profile.name || 'Arlo'}, or say what he’s done — {PROMPTS[i]}</>}
        </span>
      </span>
    </button>
  );
}
